import React from "react";
import { Button } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "store/hooks";
import { logoutAdmin } from "store/slices/authSlice";

export type CmsTopBarProps = {
  title: string;
  welcomeText?: string;
  showLogout?: boolean;
};

const CmsTopBar: React.FC<CmsTopBarProps> = ({
  title,
  welcomeText = "Welcome, Admin",
  showLogout = true,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logoutAdmin());
    navigate("/");
  };

  return (
    <div className="dashboard-top-bar">
      <div className="dashboard-top-bar-inner">
        <div className="dashboard-top-bar-left">
          <p className="dashboard-welcome mb-0">{welcomeText}</p>
          <h1 className="dashboard-title mb-0">{title}</h1>
        </div>
        <div className="dashboard-top-bar-right">
          {showLogout && (
            <Button
              type="primary"
              icon={<LogoutOutlined />}
              className="cms-logout-btn"
              onClick={handleLogout}
            >
              Logout
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CmsTopBar;
